export default {
	seo_meta_title_leaguepass: 'NBA | NBA Video e melhores momentos',
	seo_meta_desc_leaguepass: 'O NBA Video oferece vídeos e melhores momentos da NBA',
	seo_meta_keywords_leaguepass: 'Vídeos da NBA, melhores momentos da NBA, Vídeos de basquete, melhores jogadas, enterradas, recursos',
	seo_meta_title_featured: 'NBA | Destaques',
	seo_meta_desc_featured: '',
	seo_meta_keywords_featured: '',
	seo_meta_title_nbatv: 'NBA | NBA TV Live',
	seo_meta_desc_nbatv: 'O NBA TV Live é o canal de transmissão ao vivo 24 horas por dia do NBA TV, com partidas da NBA ao vivo e gravadas toda semana, programas de estúdio e análise de especialistas.',
	seo_meta_keywords_nbatv: 'NBA TV Channel, o som, clássicos inesquecíveis, nba ao vivo, nba real, nba gametime, fantasy insider, programas de estúdio, o salto',
	seo_meta_title_classicgames: 'NBA | Jogos Clássicos',
	seo_meta_desc_classicgames: '',
	seo_meta_keywords_classicgames: '',
	seo_meta_title_videolist: 'NBA | Lista de vídeos',
	seo_meta_desc_videolist: '',
	seo_meta_keywords_videolist: '',
	seo_meta_title_shows: 'NBA | Programas da NBA TV',
	seo_meta_desc_shows: '',
	seo_meta_keywords_shows: '',
	seo_meta_title_home: 'Página inicial da NBA',
	seo_meta_desc_home: '',
	seo_meta_keywords_home: '',
	seo_meta_title_channels: 'NBA | Canais',
	seo_meta_desc_channels: '',
	seo_meta_keywords_channels: '',
	seo_meta_pre_title_channel: 'NBA | Canal',
	seo_meta_pre_title_categories: 'NBA | Categorias',
	seo_meta_title_categories: 'NBA | {0}',
	seo_meta_desc_categories: '',
	seo_meta_keywords_categories: '',
	seo_meta_pre_title_category: 'NBA | Categoria',
	seo_meta_title_category: 'NBA | {0}',
	seo_meta_desc_category: '',
	seo_meta_keywords_category: '',
	seo_meta_pre_title_video: 'NBA | Vídeo',
	seo_meta_pre_title_event: 'NBA | Evento',
	seo_meta_title_events: 'NBA | Eventos',
	seo_meta_desc_events: '',
	seo_meta_keywords_events: '',
	seo_meta_title_event: 'NBA | Eventos: {0}',
	seo_meta_desc_event: '',
	seo_meta_keywords_event: '',
	seo_meta_title_search: 'NBA | Busca',
	seo_meta_desc_search: '',
	seo_meta_keywords_search: '',
	seo_meta_title_notfound: 'NBA | Página não encontrada',
	seo_meta_desc_notfound: '',
	seo_meta_keywords_notfound: '',
	seo_meta_pre_title_game: 'Jogo da NBA:',
	seo_meta_title_game: 'NBA | {0}',
	seo_meta_desc_game: '',
	seo_meta_keywords_game: '',
	seo_meta_title_video: 'NBA | NBA Video e melhores momentos',
	seo_meta_desc_video: 'O NBA Video oferece vídeos e melhores momentos da NBA',
	seo_meta_keywords_video: 'Vídeos da NBA, melhores momentos da NBA, Vídeos de basquete, melhores jogadas, enterradas, recursos',
	seo_meta_title_channel: 'NBA | NBA TV Live',
	seo_meta_desc_channel: 'O NBA TV Live é o canal de transmissão ao vivo 24 horas por dia do NBA TV, com partidas da NBA ao vivo e gravadas toda semana, programas de estúdio e análise de especialistas.',
	seo_meta_keywords_channel: 'NBA TV Channel, o som, clássicos inesquecíveis, nba ao vivo, nba real, nba gametime, fantasy insider, programas de estúdio, o salto',
	seo_meta_title_tvguide: 'NBA | Programação NBA TV',
	seo_meta_desc_tvguide: 'O NBA TV Live é o canal de transmissão ao vivo 24 horas por dia do NBA TV, com partidas da NBA ao vivo e gravadas toda semana, programas de estúdio e análise de especialistas.',
	seo_meta_keywords_tvguide: 'NBA TV Channel, o som, clássicos inesquecíveis, nba ao vivo, nba real, nba gametime, fantasy insider, programas de estúdio, o salto',
	timezone: 'BRT',
	default_feed_error_message: 'Algo deu errado, o conteúdo não está disponível no momento. Tente novamente.',
	watch_in_app: 'ASSISTIR NO APLICATIVO DA NBA',
	no_content: 'Sem conteúdo',
	see_more: 'Ver mais',
	now_playing: 'Jogando agora',
	nba_tv_lock: 'NBA TV',
	league_pass_lock: 'League Pass',
	league_pass_premium_lock: 'LP PREMIUM',
	error_max_limit_favorite: 'Você atingiu o número máximo de vídeos favoritos. Remova alguns para poder adicionar mais.',
	item_live: 'Ao vivo',
	add_favourite_title: 'ADICIONAR AOS FAVORITOS',
	remove_favourite_title: 'REMOVER DOS FAVORITOS',
	p_channel_live: 'Ao vivo',
	p_channel_schedule_title: 'Programação da NBA TV',
	p_channel_schedule_watch: 'Assistir',
	p_channel_schedule_no_date: 'Nenhuma data de programação disponível no momento.',
	p_channel_live24x7_title: 'NBA TV 24 horas, 7 dias por semana',
	p_channel_live24x7_see_full_schedule: 'Veja a programação completa',
	p_channel_live24x7_up_next: 'A seguir',
	p_channel_live24x7_on_demand: 'NBA TV: sob demanda',
	p_channel_live24x7_collection: 'Coleção',
	p_channel_live24x7_demand_1_logo_text: 'programas originais',
	p_channel_live24x7_demand_1_show_name: 'Programas da NBA TV',
	p_channel_live24x7_demand_1_show_desc: 'Programas de originais da NBA TV, incluindo Shaqtin \'a Fool, Beyond the Paint, Game Time e Basketball Stories',
	p_channel_live24x7_demand_2_logo_text: 'Jogos clássicos',
	p_channel_live24x7_demand_2_show_name: 'NBA | Jogos Clássicos',
	p_channel_live24x7_demand_2_show_desc: 'Assista a jogos clássicos completos, incluindo todas as Finais desde 2000, momentos históricos da liga e jogadores lendários',
	p_channel_clips_title: 'Clipes da NBA TV',
	p_channel_category_title: 'NBA TV',
	p_channel_playlist_title: 'Programação',
	p_nba_tv_shows: 'Programas da NBA TV',
	p_nba_tv_no_access_title: 'NBA 24 horas, 7 dias por semana: fique sempre por dentro com análises de jogos, análises de estúdio, programação original e muito mais!',
	p_nba_tv_no_access_desc: 'Assista a jogos ao vivo, além de programas e jogos clássicos sob demanda.',
	p_nba_tv_no_access_note: 'Zonas de exclusão se aplicam',
	tv_show_item_latest_episode: 'último episódio',
	tv_show_item_no_latest_episode: 'nenhum episódio recente',
	see_all: 'Ver tudo',
	header_menu_watch: 'Assistir',
	header_menu_featured: 'DESTAQUE',
	header_menu_nba_tv: 'NBA TV',
	header_menu_league_pass: 'League Pass',
	players: 'Jogadores',
	videos: 'Vídeos',
	teams: 'Equipes',
	most_searched: 'MAIS PROCURADOS',
	no_result: 'Sem dados',
	search_filter_type_most_relevant: 'Mais relevantes',
	search_filter_type_most_viewed: 'Mais vistos',
	search_filter_type_most_recent: 'Mais recentes',
	search_filter_type_last_30_days: 'Últimos 30 dias',
	search_filter_type_last_6_months: 'Últimos 6 meses',
	search_result_label: 'Resultados da busca por \'{keyword}\'',
	search_result_info: 'Exibir todos os resultados para {keyword}',
	search_placeholder: 'Buscar na videoteca',
	load_more: 'Carregar mais...',
	button_subscribe: 'Assine',
	button_sign_in: 'Entrar',
	p_league_pass_no_access_title: 'Assista a jogos ao vivo ou em reprise em qualquer aparelho, incluindo computador, smartphone e TV!',
	p_league_pass_no_access_desc: 'Seu ingresso para a ação: assista a toda a liga ou seu time favorito, escolha um único jogo ou confira mais opções.',
	p_league_pass_no_access_note: 'Termos se aplicam',
	category_title: 'Vídeo',
	p_video_playlist_title: 'Playlist',
	p_no_access_league_pass_title: 'Desbloqueie o NBA League Pass para assistir:',
	p_no_access_league_pass_desc: 'Seu ingresso para a ação: assista a toda a liga ou seu time favorito, escolha um único jogo ou confira mais opções.',
	p_no_access_league_pass_terms: 'Termos se aplicam',
	p_no_access_league_pass_geo_desc: 'Com base na sua localização atual, não é possível assistir a este jogo pelo NBA League Pass ou NBA TV. Estes jogos estarão arquivados e disponíveis para assinantes do NBA League Pass 3 dias após a transmissão. Consulte as programações das suas emissoras locais de TV e rádio para saber onde encontrar as transmissões na sua área.',
	p_no_access_league_pass_not_found_desc: 'Desculpe, o vídeo solicitado não foi encontrado.',
	p_no_access_event_not_found_desc: 'Desculpe, o evento solicitado não foi encontrado.',
	p_no_access_nba_tv_title: 'Desbloqueie a NBA TV para assistir:',
	p_no_access_nba_tv_desc: 'Assista a jogos ao vivo, além de programas e jogos clássicos sob demanda.',
	p_no_access_nba_tv_terms: 'Termos se aplicam',
	p_no_access_nba_tv_geo_desc: 'Com base na sua localização atual, não é possível assistir a este jogo pelo NBA League Pass ou NBA TV. Estes jogos estarão arquivados e disponíveis para assinantes do NBA League Pass 3 dias após a transmissão. Consulte as programações das suas emissoras locais de TV e rádio para saber onde encontrar as transmissões na sua área.',
	p_no_access_nba_tv_not_found_desc: 'Desculpe, o canal solicitado não foi encontrado.',
	p_no_access_up_next: 'A seguir',
	p_video_completed_title: 'Playlist completa',
	p_video_completed_desc: 'Volte para navegar ou confira a próxima playlist para você',
	p_video_share_to: 'Compartilhar em:',
	p_video_more_to_watch: 'Mais para assistir:',
	p_event_section_title: 'EVENTO',
	p_event_playlist_title: 'Playlist:',
	p_event_button_watch: 'Assistir',
	p_event_button_listen: 'Ouvir',
	p_event_button_ticket: 'Ingresso',
	notfound: 'Desculpe, a página solicitada não foi encontrada.',
	notfound_desc: 'Verifique se há erro no URL.<br/>Você também pode tentar usar a ferramenta de navegação ou de busca do site para encontrar o conteúdo que quer.',
	modal_pcm_header_title: '',
	modal_pcm_body_title: '',
	modal_pcm_body_description: 'Sua conta do NBA League Pass atingiu seu número máximo de streams. Toque em \'Continuar\' para voltar a assistir neste aparelho.',
	modal_pcm_custom: 'CONTINUAR',
	modal_pcm_close: 'Cancelar',
	modal_adobe_concurrency_header_title: 'Conexão de vídeo perdida',
	modal_adobe_concurrency_body_title: '',
	modal_adobe_concurrency_body_description: 'Seu stream foi fechado. Possíveis razões incluem: limite máximo de streams simultâneos atingido, perda de rede ou erro técnico. Faça login novamente e selecione um canal para continuar.',
	modal_adobe_concurrency_close: 'Concluído',
	modal_video_unsupported_header_title: '',
	modal_video_unsupported_body_title: '',
	modal_video_unsupported_body_description: 'Este vídeo não pode ser reproduzido no seu aparelho. Clique <a href=\'https://neulion-a.akamaihd.net/nlweb/h5support/player.html\' target=\'_blank\'>AQUI</a> para obter mais ajuda.',
	modal_video_unsupported_custom: '',
	modal_video_unsupported_close: 'Ok',
	freesample_notice_time: 'Tempo restante',
	freesample_notice_title: 'Aproveite os {0} minutos de acesso',
	freesample_notice_desc: 'Assine um pacote completo do League Pass para continuar a ter acesso ao conteúdo após o fim dos {0} minutos.',
	freesample_notice_subscribe_button: 'Assine',
	freesample_notice_cancel_button: 'CANCELE A QUALQUER MOMENTO',
	freesample_popup_title: 'O ACESSO TERMINOU',
	freesample_popup_subtitle: 'Assine o League Pass para assistir a ainda mais conteúdo da NBA.',
	freesample_popup_link: 'Saiba mais',
	freesample_popup_get_minutes_button: 'RECEBER {0}  MINUTOS',
	reg_required_desc: 'Você precisa fazer login para ver este conteúdo',
	favorite_teams_title: 'Equipes favoritas',
	bookmarked_title: 'Salvo',
	watch_history_title: 'Continue assistindo',
	game_schedule_title: 'Calendário de jogos',
	recommended_title: 'Recomendado',
	season_text: 'Temporada',
	section_tv_provider_title: 'Meu provedor de TV',
	section_tv_provider_desc: 'Acesse jogos e transmissões ao vivo de seu provedor de TV.',
	section_tv_provider_faq: 'Perguntas frequentes sobre provedores de TV',
	section_tv_provider_sign_out: 'Sair',
	header_menu_account_my_account: 'Minha conta',
	header_menu_account_manage_account: 'Gerenciar conta',
	header_menu_account_favorite_teams: 'Equipes favoritas',
	header_menu_account_favorite_players: 'Jogadores favoritos',
	header_menu_account_viewing_history: 'Histórico de visualizações',
};
